import { Wand2Icon } from '@/components/icons/lucide';
import React, { useCallback } from 'react';

import { StaggeredText } from '@/components/ui/staggered-text';
import { useDemoRequestModal } from '@/providers/modal/demo-request-modal';
import { useUser } from '@/states/auth';
import { useSignInModal } from '@/providers/modal/states';
import { Button } from '@/components/button';

export const VideoGridPlaceholder = React.memo(() => {
  const user = useUser();
  const demoRequestModal = useDemoRequestModal();
  const signInModal = useSignInModal();

  const handleDemoRequest = useCallback(() => {
    if (!user?.email) {
      signInModal.open();
      return;
    }
    demoRequestModal.open();
  }, [demoRequestModal, signInModal, user?.email]);

  return (
    <div className="flex justify-center flex-col items-center pt-16 pb-24 animate-fade-in">
      <StaggeredText
        text={`Empty.
But it can be filled.`}
        fontSize={22}
        letterSpacing={0}
        className="bg-gradient-to-r from-white to-white/80 text-transparent bg-clip-text"
      />

      <Button
        onClick={handleDemoRequest}
        variant="outline"
        size="md"
        className="mt-8"
      >
        <Wand2Icon className="w-4 h-4 mr-2" />
        Request
      </Button>
      <div className="mb-36" />
    </div>
  );
});
